<div
  class="be-inline-container"
  [ngClass]="{
    'mb-4': showNotesSection(),
  }"
  [ngStyle]="{
    width: showNotesSection() ? '1200px' : '1220px',
  }"
>
  <ag-grid-angular
    class="ag-theme-aux be-inline-table tabular-nums"
    [ngStyle]="{
      height: showNotesSection() ? '300px' : '530px',
    }"
    [rowData]="filteredRowData"
    (gridReady)="onGridReady($event)"
    [gridOptions]="gridOptions"
    [getRowId]="getRowId"
    (cellEditingStopped)="onCellEdit($event)"
    (cellValueChanged)="onCellChanged($event)"
  />
</div>
